import { render, staticRenderFns } from "./ProfessionalDashboard.vue?vue&type=template&id=e85856ea&scoped=true"
import script from "./ProfessionalDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalDashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProfessionalDashboard.vue?vue&type=style&index=0&id=e85856ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85856ea",
  null
  
)

export default component.exports